import React, { useState } from 'react';
const ValueOfWhatCalculator = () => {
  const [value1, setValue1] = useState('');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');
  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('Please enter both values correctly');
      setResult('');
      setExplanation('');
      return;
    }
    const percentageOfWhat = (parseFloat(value1) / parseFloat(value2)) * 100;
    setResult(percentageOfWhat.toFixed(2));
    setExplanation(
      `${value1} is ${percentageOfWhat.toFixed(2)}% of ${value2} = (${value1} / ${value2}) * 100 = ${
        (parseFloat(value1) / parseFloat(value2)) * 100
      } = ${percentageOfWhat.toFixed(4)}`
    );
    setError('');
  };
  return (
    <div dir="ltr">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="number"
          placeholder="Value"
          value={value1}
          onChange={(e) => setValue1(e.target.value)}
          className="form-control ml-2"
          style={{ width: '80px' }}
        />
        <span>is</span>
        <input
          type="number"
          placeholder="Percentage"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          className="form-control ml-2"
          style={{ width: '80px', marginLeft: '5px', marginRight: '5px' }}
        />
        <span>% of what</span>
        <button
          className="btn btn-success"
          style={{ fontSize: '20px',  marginRight: '5px'  }}
          onClick={handleCalculate}
        >
          Calculate
        </button>
      </div>
      <br />
      <div>
        {error !== '' ? (
          <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
        ) : (
          <>
            {result !== '' && (
              <>
                <p className='p-3 mb-2 bg-success text-white'>
                  Result: {value1} is {value2}% of {result}
                </p>
                {explanation !== '' && (
                  <p className='p-3 mb-2 bg-info text-black'>
                    Solution Steps: <br/>{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default ValueOfWhatCalculator;
